import RSAUtils from "./rsa.js";
import { privateKey } from "@/api/token";

const publicExponent = "10001";

const encryption = {
  /**
   * 传入需要加密的字符串,输出经过URL编码再经RSA加密的密文
   * @param reqStr    需要加密的字符串
   * @returns    加密后的密文
   */
  async encryptedReqstr(reqStr) {
    //获取加密秘钥
    let { data } = await privateKey("16");
    const key = RSAUtils.getKeyPair(publicExponent, "", data);
    //使用加密秘钥加密密码
    return RSAUtils.encryptedString(key, reqStr);
  }
};

export default encryption;
